var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('agile',{attrs:{"arrows":true,"speed":750,"timing":'linear',"fade":true,"autoplay":true,"pauseOnHover":false}},[_c('div',{staticClass:"slide slide--1"}),_c('div',{staticClass:"slide slide--2"})])}
var staticRenderFns = []

export { render, staticRenderFns }